import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useCertificates = defineStore('certificates', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.certificate_ListCertificates,
    dto: 'CertificateDto',
    create: api.certificate_CreateCertificate,
    update: api.certificate_UpdateCertificate,
    delete: api.certificate_DeleteCertificate,
    usage: api.certificate_GetCertificateUsage,
    signalR: 'CertificateUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
